import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { SessionService } from '../../../shared/services/session.service';
declare var createjs: any;

@Component({
  selector: 'app-yr3-wb-popup-pg52',
  templateUrl: './yr3-wb-popup-pg52.component.html',
  styleUrls: ['./yr3-wb-popup-pg52.component.scss']
})
export class Yr3WbPopupPg52Component implements OnInit {

 public bloburl: string;

  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<Yr3WbPopupPg52Component>) {

    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {

    var bloburl = this.sessionService.bloburl;
    var stage = new createjs.Stage("yr3_canvas");
    createjs.Touch.enable(stage);

var yr3_canvas: any = document.getElementById('yr3_canvas');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 885;



    var yr3_bitmap = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-WB/Pages/Chapter6/Page52/Popup/frame.png");
    yr3_bitmap.setTransform(0, 0, 0.992, 0.965);

    var bitmap4 = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-WB/Pages/Chapter6/Page52/Popup/YR3_WB_Page52_img01.png");
    bitmap4.setTransform(290, 140, 0.72, 0.72);


    stage.addChild(yr3_bitmap, bitmap4);
    stage.enableMouseOver();
    stage.mouseMoveOutside = false;
    createjs.Ticker.setFPS(60);
    createjs.Ticker.addEventListener("tick", stage);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
    stage.update();
  }
  onCloseCancel() {
    this.thisDialogRef.close('Cancel');
  }
}

